/*
 * Saracen scroll reveal + mobilní pořadí karet (reusable, používá bento).
 * - Kontejnery [data-scroll-reveal]; když dojedou do viewportu, dostanou
 *   třídu "reveal-in" -> CSS spustí staggered animaci položek.
 * - Položky [data-reveal-item] dostanou --reveal-index (pro stagger i stack).
 * - MOBILNÍ POŘADÍ: položky s [data-mobile-order] se na mobilu (<750px)
 *   fyzicky přeskládají v DOM podle čísla (menší = výš). Na desktopu se vrací
 *   původní pořadí. Fyzické přeskládání funguje spolehlivě i s display:contents
 *   (na rozdíl od CSS `order`, které se u takto povýšených položek neuplatní).
 * - Respektuje prefers-reduced-motion. Idempotentní + Shopify editor.
 */
(function () {
  if (window.__saracenRevealInit) return;
  window.__saracenRevealInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var MOBILE = '(max-width: 749px)';

  function applyOrder(container) {
    var orig = container.__revealOrigOrder;
    if (!orig) return;

    var isMobile = window.matchMedia(MOBILE).matches;
    var cells = orig.slice();

    if (isMobile) {
      cells = cells
        .map(function (cell, i) {
          var item = cell.matches('[data-reveal-item]') ? cell : cell.querySelector('[data-reveal-item]');
          var ord = item ? parseFloat(item.getAttribute('data-mobile-order')) : 0;
          if (isNaN(ord)) ord = 0;
          return { cell: cell, ord: ord, i: i };
        })
        .sort(function (a, b) {
          return a.ord - b.ord || a.i - b.i;
        })
        .map(function (o) {
          return o.cell;
        });
    }

    // Přeskládat v DOM jen když je potřeba (ať zbytečně nesaháme na layout)
    var current = Array.prototype.slice.call(container.children);
    var changed = cells.length !== current.length;
    for (var k = 0; !changed && k < cells.length; k++) {
      if (cells[k] !== current[k]) changed = true;
    }
    if (changed) {
      cells.forEach(function (cell) { container.appendChild(cell); });
    }

    // Reindex podle aktuálního (nového) pořadí v DOM
    var items = container.querySelectorAll('[data-reveal-item]');
    for (var j = 0; j < items.length; j++) {
      items[j].style.setProperty('--reveal-index', j);
    }
  }

  function initContainer(container) {
    if (container.dataset.revealReady) return;

    // Uložit původní pořadí buněk (pro obnovení na desktopu)
    container.__revealOrigOrder = Array.prototype.slice.call(container.children);
    applyOrder(container);

    if (reduce || !('IntersectionObserver' in window)) {
      container.classList.add('reveal-in');
      container.dataset.revealReady = 'done';
      return;
    }

    container.dataset.revealReady = 'true';
    container.classList.add('reveal-ready');

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -30% 0px' }
    );
    io.observe(container);
  }

  function initAll(root) {
    var scope = root || document;
    var containers = scope.querySelectorAll('[data-scroll-reveal]');
    for (var i = 0; i < containers.length; i++) initContainer(containers[i]);
  }

  // Přeskládat všechny kontejnery při změně šířky (přepnutí mobil/desktop)
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-scroll-reveal]').forEach(applyOrder);
    }, 150);
  });

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
